import { ShieldCheck } from "lucide-react";

export const PrivacyBanner = ({ lang = "fr" }) => {
  const t =
    lang === "fr"
      ? {
          strong: "Zéro compte, zéro cookie, zéro donnée stockée.",
          soft: "Ton message est reformulé à la volée puis oublié.",
        }
      : {
          strong: "No account, no cookies, no data stored.",
          soft: "Your message is rephrased on the fly, then forgotten.",
        };
  return (
    <div
      data-testid="privacy-banner"
      className="bg-[#B5EAD7] border-b-2 border-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2.5 flex items-center justify-center gap-2 text-center">
        <ShieldCheck className="w-4 h-4 flex-shrink-0" />
        <p className="text-xs sm:text-sm font-bold leading-tight">
          {t.strong}{" "}
          <span className="font-medium text-[#2A4A3E] hidden sm:inline">
            {t.soft}
          </span>
        </p>
      </div>
    </div>
  );
};
